import { makeStyles } from "@material-ui/core";
import { colors } from "~/utils/colors";

const { background, brand, white } = colors;

const MuiStylesAppointmentSummary = makeStyles((theme) => ({
	container: {
		padding: "8px",
		//backgroundColor: background?.default,
		minHeight: "24vh",
		position: "relative",
	},
	headerSection: {
		display: "flex",
		alignItems: "center",
		marginBottom: "6px",
	},
	businessAvatar: {
		width: "55px",
		height: "55px",
		backgroundColor: "#8C1837",
		color: "white",
		fontSize: "18px",
		fontWeight: "bold",
		marginRight: "12px",
		display: "flex",
	},
	businessInfo: {
		flex: 1,
	},
	businessName: {
		fontSize: "clamp(1.2rem, 1vw, 2rem)",
		fontWeight: "bold",
		color: "#222",
	},
	businessAddress: {
		fontSize: "clamp(0.8rem, 1vw, 1.2rem)",
		color: "#666",
	},
	arrowIcon: {
		color: "#666",
	},
	contactSection: {
		display: "flex",
		justifyContent: "center",
		gap: "2rem",
		marginBottom: "24px",
	},
	contactItem: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		cursor: "pointer",
	},
	contactIcon: {
		width: "35px",
		height: "35px",
		borderRadius: "50%",
		backgroundColor: "#8C1837",
		color: "white",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		marginBottom: "8px",
	},
	iconSize: {
		fontSize: "20px",
	},
	contactLabel: {
		fontSize: "12px",
		color: "#666",
	},
	summaryCard: {
		borderRadius: "12px",
		boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
		marginBottom: "10px",
	},
	summaryTitle: {
		fontSize: "clamp(1.4rem, 1vw, 1.4rem)",
		fontWeight: "500",
		color: "#222",
		letterSpacing: "-0.5px",
		fontFamily: "CircularStd",
	},
	historyInfo: {
		fontSize: "14px",
		marginBottom: "8px",
	},
	historyBlue: {
		color: "#3689ea",
	},
	appointmentDateTime: {
		fontSize: "clamp(1.1rem, 1vw, 1.4rem)",
		fontWeight: "500",
		color: "#222",
		marginTop: "16px",
		marginBottom: "2px",
		fontFamily: "CircularStd",
		letterSpacing: "-0.5px",
	},
	professionalSection: {
		display: "flex",
		alignItems: "center",
		marginBottom: "16px",
	},
	professionalAvatar: {
		width: "60px",
		height: "60px",
		marginRight: "12px",
	},
	professionalInfo: {
		display: "flex",
		flexDirection: "column",
		alignItems: "flex-start",
	},
	professionalName: {
		fontSize: "clamp(1.1rem, 1vw, 1.4rem)",
		fontWeight: "500",
		color: "#222",
		fontFamily: "CircularStd",
		letterSpacing: "-0.5px",
	},
	serviceInfo: {
		fontSize: "clamp(1rem, 1vw, 1.4rem)",
		color: "#222",
		marginBottom: "8px",
		fontFamily: "CircularStd",
		letterSpacing: "-0.5px",
	},
	priceTag: {
		backgroundColor: "#f0f0f0",
		color: "#666",
		padding: "4px 8px",
		borderRadius: "12px",
		fontSize: "12px",
		display: "inline-block",
	},
	paymentInfo: {
		fontSize: "14px",
		color: "#666",
		marginBottom: "16px",
	},
	balanceInfo: {
		fontSize: "16px",
		fontWeight: "bold",
		color: "#222",
	},
	actionButtons: {
		display: "flex",
		gap: "12px",
		marginTop: "24px",
	},
	footerBar: {
		position: "fixed",
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "white",
		padding: "12px 16px calc(env(safe-area-inset-bottom) + 12px)",
		zIndex: 1000,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		"& > div": {
			width: "100%",
			maxWidth: "460px",
			display: "flex",
			flexDirection: "column",
			gap: "6px",
		},
	},
	cancelButtonFooter: {
		backgroundColor: "transparent", 
		cursor: "unset",
		margin: "4px",
		padding: "7px",
		color: "#222",
		height: 44,
		fontSize: "15px",
		display: "flex",
		width: "100%",
		borderRadius: "25.5px",
		flex: 1,
		border: "1px solid #222",
		cursor: "pointer",
		"&:active": {
			backgroundColor: brand?.default,
			color: "white",
			border: "none"
		},
	},
	actionButtonFooter: {
		backgroundColor: "transparent", 
		cursor: "unset",
		margin: "4px",
		padding: "7px",
		color: "#222",
		height: 44,
		fontSize: "15px",
		display: "flex",
		width: "100%",
		borderRadius: "25.5px",
		flex: 1,
		border: "1px solid #222",
		cursor: "pointer",
		"&:active": {
			backgroundColor: brand?.default,
			color: "white",
			border: "none"
		},
	},
	confirmButtonFooter: {
		backgroundColor: brand?.default, 
		margin: "4px",
		padding: "7px",
		color: white,
		height: 44,
		fontSize: "15px",
		display: "flex",
		width: "100%",
		borderRadius: "25.5px",
		flex: 1,
		cursor: "pointer",
		"&:active": {
			backgroundColor: brand?.dark,
			color: white,
		},
		"&:hover": {
			backgroundColor: brand?.dark,
			color: white,
		},
	},
	changeButton: {
		flex: 1,
		backgroundColor: "#8C1837",
		color: "white",
		borderRadius: "8px",
		padding: "12px 24px",
		fontSize: "16px",
		fontWeight: "bold",
		textTransform: "none",
		"&:hover": {
			backgroundColor: "#6e1228",
		},
		"&:active": {
			backgroundColor: "#DC143C",
			color: "white",
		},
	},
	cancelButton: {
		flex: 1,
		backgroundColor: "#f5f5f5",
		color: "#666",
		border: "1px solid #ddd",
		borderRadius: "8px",
		padding: "12px 24px",
		fontSize: "16px",
		fontWeight: "bold",
		textTransform: "none",
		"&:hover": {
			backgroundColor: "#e0e0e0",
		},
		"&:active": {
			backgroundColor: "#DC143C",
			color: "white",
		},
	},
	fullWidthButton: {
		flex: 1,
		backgroundColor: "#8C1837",
		color: "white",
		borderRadius: "8px",
		padding: "12px 24px",
		fontSize: "16px",
		fontWeight: "bold",
		textTransform: "none",
		margin: "0 4px",
		"&:hover": {
			backgroundColor: "#6e1228",
		},
		"&:active": {
			backgroundColor: "#DC143C",
			color: "white",
		},
	},
}));

export default MuiStylesAppointmentSummary;
